import { useSearchParams } from '@starsoft/common/hooks';
import { AuthStep } from '@/enums/auth/authStep';

export function useIsKycAuthStep() {
  const search = useSearchParams();
  const isKyc = search.get('step') === AuthStep.Kyc;

  return {
    isKyc,
  };
}
